/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { Namespaces } from '../../i18n';
import { EntityThumbnail } from '../EntityThumbnail/EntityThumbnail';
import { useOidcProviderButtonStyles } from './OidcProviderButton.styles';

type OidcProviderButtonProps = {
  variant?: 'contained';
  redirect: string;
  organizationName: string;
  thumbnailSrc: string;
};

export const OidcProviderButton = memo<OidcProviderButtonProps>(props => {
  const { variant = 'outlined', redirect, organizationName, thumbnailSrc } = props;
  const { t } = useTranslation();

  const classes = useOidcProviderButtonStyles();

  return (
    <Button
      variant={variant}
      href={redirect}
      fullWidth
      startIcon={
        <EntityThumbnail
          type="custom_src"
          src={thumbnailSrc}
          allowUploadImage={false}
          className={cx({
            [classes.thumbnail]: variant === 'contained',
          })}
        />
      }
      data-cy={`sso-login-continue-with-${organizationName}`}
    >
      <div className={classes.textNoWrap}>
        {t(`${Namespaces.Login}:page.login.continue_with_button`, {
          name: organizationName,
        })}
      </div>
    </Button>
  );
});
